export default __webpack_public_path__ + "static/media/edit_business.a4a3e823.svg";